import { render } from "./result-item.vue?vue&type=template&id=72725918&scoped=true"
import script from "./result-item.vue?vue&type=script&lang=js"
export * from "./result-item.vue?vue&type=script&lang=js"

import "./result-item.vue?vue&type=style&index=0&id=72725918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72725918"]])

export default __exports__